export enum ValidationStatus {
  Valid = 'valid',
  Warning = 'warning',
  Invalid = 'invalid',
  Info = 'info'
}

export enum WorkOrderStatus {
  Compliant = 'compliant',
  Warning = 'warning',
  NonCompliant = 'non-compliant'
}

export enum ValidationItemType {
  Timesheet = 'timesheet',
  Expense = 'expense',
  Manual = 'manual',
  Total = 'total'
}
